import "./ReturnLinesTable.scss";

function ReturnLinesConditions() {
    const conditionNew = { name: "new", letter: "N" };
    const conditionUsed = { name: "used", letter: "U" };
    const conditionDefective = { name: "worthless", letter: "U" };

    return { conditionNew, conditionUsed, conditionDefective }
}

function ReturnLinesTable({ dataSource, sentLines }) {
    const conditions = ReturnLinesConditions();
    const sentLinesString = sentLines.map((x) => x.lineSkuSent);

    return (
        dataSource.map((line, index) => {
            let returnLineCondition = "";
            const isLineDefective = sentLines.some((x) => x.defective === true && x.lineSkuSent !== null && x.lineSkuSent.split("-")[0] === line.skus[0].itemUid);

            if (!isLineDefective) {
                let sentLine;

                line.skus.forEach(sku => {
                    if (!sentLine) {
                        sentLine = sentLinesString.find((x) => x === sku.uid);
                    }
                });

                if (sentLine) {
                    if (sentLine.split("-")[1] === conditions.conditionNew.letter) {
                        returnLineCondition = conditions.conditionNew.name;
                    } else {
                        returnLineCondition = conditions.conditionUsed.name;
                    }
                }
            } else {
                returnLineCondition = conditions.conditionDefective.name;
            }

            return (
                <div className="return-lines-wrapper">
                    <div className="header">
                        <p><span className="return-title">#{index + 1}</span> - {line.uid}</p>
                        {returnLineCondition && <p className="sent-condition">{returnLineCondition}</p>}
                    </div>
                    <table className="basic-table-wrapper">
                        <tr>
                            <th width="34%">Uid</th>
                            <th width="26%">Item Uid</th>
                            <th width="26%">Condition</th>
                            <th width="26%">Selected</th>
                        </tr>
                        {line.skus.map((sku) => {
                            let icon = <></>;

                            if (!isLineDefective) {
                                icon = sentLinesString.some((x) => x === sku.uid) ? (
                                    <span className="icon checked">check_circle</span>
                                ) : (
                                    <span className="icon">radio_button_unchecked</span>
                                );
                            } else {
                                icon = <span className="icon disturb">do_disturb_on</span>;
                            }

                            return (
                                <tr>
                                    <td width="34%">{sku.uid}</td>
                                    <td width="26%">{sku.itemUid}</td>
                                    <td width="26%">{sku.condition}</td>
                                    <td width="26%">{icon}</td>
                                </tr>
                            )
                        })}
                    </table>
                </div>
            )
        })
    )
}

export default ReturnLinesTable;